import React from "react";
import { ArrowRight } from "lucide-react";
import { BLOGS } from "../mock";
import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";

const BlogsSection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-16 sm:py-20 bg-[#f7f9fc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 gap-4">
          <div>
            <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Our Articles</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">Blogs on Dry Cleaning &amp; Laundry</h2>
          </div>
          <button onClick={() => navigate("/blog")} className="inline-flex items-center gap-2 text-navy font-semibold hover:text-orange-brand transition-colors self-start sm:self-auto">
            More Articles <ArrowRight size={18} />
          </button>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {BLOGS.map((b, i) => (
            <Reveal key={b.title} delay={i * 60}>
              <article onClick={() => navigate("/blog")} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all cursor-pointer h-full flex flex-col">
                <div className="overflow-hidden h-44">
                  <img src={`${b.img}?w=500&q=75`} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-semibold text-navy font-head leading-snug group-hover:text-orange-brand transition-colors line-clamp-2">{b.title}</h3>
                  <p className="text-sm text-navy/60 mt-2 line-clamp-3 flex-1">{b.excerpt}</p>
                  <span className="text-orange-brand font-semibold text-sm mt-4 inline-flex items-center gap-1.5">Read More <ArrowRight size={15} /></span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogsSection;
